var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_238)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4375 33.125V41.5625L58.6875 47.1875H49.3125L45.5625 41.5625V33.125H62.4375Z",
    fill: "#8FB16A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.25 25.625H27.75C26.7141 25.625 25.875 24.7859 25.875 23.75V21.875H82.125V23.75C82.125 24.7859 81.2859 25.625 80.25 25.625Z",
    fill: "#8FB16A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 25.625V29.375C35.25 31.4459 36.9291 33.125 39 33.125H69C71.0709 33.125 72.75 31.4459 72.75 29.375V25.625H35.25ZM59.1562 50H48.8438C48.0675 50 47.4375 49.37 47.4375 48.5938C47.4375 47.8175 48.0675 47.1875 48.8438 47.1875H59.1562C59.9325 47.1875 60.5625 47.8175 60.5625 48.5938C60.5625 49.37 59.9325 50 59.1562 50Z",
    fill: "#8FB16A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56.5625L51.6168 60.0922C50.5621 61.6541 51.539 63.7925 53.5706 64.0372C53.7112 64.0541 53.8546 64.0625 54 64.0625C54.1453 64.0625 54.2887 64.0541 54.4293 64.0372C56.4609 63.7925 57.4378 61.6541 56.3831 60.0922L54 56.5625Z",
    fill: "#8FB16A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 70.625L51.6169 74.1547C50.5622 75.7166 51.5391 77.855 53.5706 78.0997C53.7113 78.1166 53.8547 78.125 54 78.125C54.1453 78.125 54.2888 78.1166 54.4294 78.0997C56.461 77.855 57.4378 75.7166 56.3831 74.1547L54 70.625ZM43.6875 53.75L39.5072 54.5609C37.6575 54.92 36.8363 57.1222 38.0991 58.7319C38.1863 58.8434 38.2819 58.9503 38.385 59.0534C38.4881 59.1566 38.596 59.2513 38.7066 59.3394C40.3163 60.6022 42.5185 59.7809 42.8775 57.9312L43.6875 53.75Z",
    fill: "#8FB16A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 65L31.0697 65.8109C29.22 66.17 28.3988 68.3722 29.6616 69.9819C29.7488 70.0934 29.8444 70.2003 29.9475 70.3034C30.0506 70.4066 30.1585 70.5013 30.2691 70.5894C31.8788 71.8522 34.081 71.0309 34.44 69.1812L35.25 65Z",
    fill: "#8FB16A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3125 53.75L68.4928 54.5609C70.3425 54.92 71.1637 57.1222 69.9009 58.7319C69.8137 58.8434 69.7181 58.9503 69.615 59.0534C69.5119 59.1566 69.4041 59.2513 69.2934 59.3394C67.6837 60.6022 65.4816 59.7809 65.1225 57.9312L64.3125 53.75Z",
    fill: "#8FB16A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.75 65L76.9303 65.8109C78.78 66.17 79.6012 68.3722 78.3384 69.9819C78.2512 70.0934 78.1556 70.2003 78.0525 70.3034C77.9494 70.4066 77.8416 70.5013 77.7309 70.5894C76.1212 71.8522 73.9191 71.0309 73.56 69.1812L72.75 65Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_238",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_238",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerSystem);
export default __webpack_public_path__ + "static/media/sprinklerSystem.9bda206d120f1ad1154934a3181c9c14.svg";
export { ForwardRef as ReactComponent };